module.exports = __webpack_public_path__ + "img/ic-loading-danger.cdf46049.svg";